import React, {  useState } from 'react'
import { Link } from "react-router-dom";
 import Slider from 'react-slick';
 import { getUserData } from '../auth';
import { useSelector } from 'react-redux';
 import {  useGetShopProfilesStatusAndProfileIdQuery } from '../apis/ShopProfileApi';

     const ProductDetailsReturnedOneAmazon = () => {

        const product = useSelector((state) => state.product.selectedProduct);
 
        const userData = getUserData();
        const userId = userData?.uid || "";
       // console.log('userId userId',userId);

      const { data:profileInfo, error:errorProfileInfo, isLoading:isLoadingProfileInfo } = useGetShopProfilesStatusAndProfileIdQuery(userId, {
        skip: !userId, // Skip the query if userId is not available
      });
      
     console.log('product product',product);
     console.log('profileInfo profileInfo',profileInfo);

    const productImages = product?.images || [
        "assets/images/thumbs/product-details-thumb1.png",
        "assets/images/thumbs/product-details-thumb2.png",
        "assets/images/thumbs/product-details-thumb3.png",
        "assets/images/thumbs/product-details-thumb2.png",
    ];
 

    // increment & decrement
     const [mainImage, setMainImage] = useState(productImages[0]);

    const settingsThumbs = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
    };
      
    return (
        <section className="product-details py-80">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-lg-9">
                        <div className="row gy-4">
                            <div className="col-xl-6">
                                <div className="product-details__left">
                              
                                    <div className="product-details__thumb-slider border border-gray-100 rounded-16">
                                        <div className="">

                                            <div className="product-details__thumb flex-center h-100">
                                           
                                                <img src={mainImage} alt="Main Product" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-24">
                                        <div className="product-details__images-slider">
                                            <Slider {...settingsThumbs}>
                                                {productImages.map((image, index) => (
                                                    <div className="center max-w-120 max-h-120 h-100 flex-center border border-gray-100 rounded-16 p-8" key={index} onClick={() => setMainImage(image)}>
                                                        <img className='thum' src={image} alt={`Thumbnail ${index}`} />
                                                    </div>
                                                ))}
                                            </Slider>



                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="product-details__content">
                                    <h5 className="mb-12">{product?.name}</h5>
                                    <div className="flex-align flex-wrap gap-12">
                                        <div className="flex-align gap-12 flex-wrap">
                                            <div className="flex-align gap-8">
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                            </div>
                                            <span className="text-sm fw-medium text-neutral-600">
                                            {product?.ratings} Star Rating
                                            </span> 
                                        </div>
                                        
                                    </div>
                                    <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                                    <p className="text-gray-700">
                                        {product?.description}
                                    </p>
                                    <div className="mt-32 flex-align flex-wrap gap-32">
                                        <div className="flex-align gap-8">
                                            <h4 className="mb-0"> 
                                          ${product?.price - product?.discount}
                                            </h4>
                                            <span className="text-md text-gray-500 text-decoration-line-through">
                                            ${product?.price}
                                                </span>
                                        </div>  
 
 
                                    </div>
                                    
                                    <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                                   
                                    
                                    <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                                    
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="product-details__sidebar border border-gray-100 rounded-16 overflow-hidden">
                            <div className="p-24">
                                <div className="flex-between bg-main-600 rounded-pill p-8">
                                    <div className="flex-align gap-8">
                                        <span className="w-44 h-44 bg-white rounded-circle flex-center text-2xl">
                                            <i className="ph ph-storefront" />
                                        </span>
                                        <span className="text-white">by Blink Buy</span>
                                    </div>
                                    <Link
                                        to="/shop"
                                        className="btn btn-white rounded-pill text-uppercase"
                                    >
                                       My Store
                                    </Link>
                                </div>
                            </div>
                            <div className="p-24 bg-white d-flex align-items-start gap-24 border-bottom border-gray-100">
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-truck" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Fast Delivery</h6>
                                    <p className="text-gray-700">
                                        Lightning-fast shipping, guaranteed.
                                    </p>
                                </div>
                            </div>
                            <div className="p-24 bg-white d-flex align-items-start gap-24 border-bottom border-gray-100">
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-arrow-u-up-left" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">returning product</h6>
                                    <p className="text-gray-700">Once a product is added to your store, it cannot be removed unless you request its deletion.</p>
                                </div>
                            </div>
                           
                            <div className="p-24 bg-white d-flex align-items-start gap-24 border-bottom border-gray-100">
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-credit-card" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Payment</h6>
                                    <p className="text-gray-700">
                                    Please note that your customers will be able to pay in Bitcoin, Ethereum, or USDT upon receipt of goods.                                    </p>
                                </div>
                            </div> 
                            
                        </div>
                    </div>
                </div> 
                
            </div>
        </section>

    )
}

export default ProductDetailsReturnedOneAmazon